const exportedObject = {
  consultarCargaPantallasData: {},
  consultarCargaPantallasLoading: false,
  consultarCargaPantallasError: null,
};

export default exportedObject;

